/*
----------------------------
Module - smp-table-responsive
----------------------------
*/

import $ from 'jquery';

(function(){

    'use strict';

    
    squiz.fn.responsiveTable = function() {

        // Setup feature which allows user to click and drag overflow tables (including dynamically added) on mobile view
        function setupDragToScroll() {
            
            var $table_wrapper = $table.parent();

            $table_wrapper.on('mousedown', function(event) {

                var $this_table_wrapper = $(event.currentTarget);

                isDown = true;

                $this_table_wrapper.addClass(table_wrapper_active_class);

                startX = event.pageX - $this_table_wrapper[0].offsetLeft;
                
                scrollLeft = $this_table_wrapper[0].scrollLeft;

            });

            $table_wrapper.on('mousemove', function(event) {
                
                event.preventDefault();

                if(!isDown) return;

                var $this_table_wrapper = $(event.currentTarget);

                var x = event.pageX - $this_table_wrapper[0].offsetLeft;

                var walk = (x - startX);

                $this_table_wrapper[0].scrollLeft = scrollLeft - walk;

            });

            $table_wrapper.on('mouseleave', function(event) {

                var $this_table_wrapper = $(event.currentTarget);

                isDown = false;

                $this_table_wrapper.removeClass(table_wrapper_active_class);

            });

            $table_wrapper.on('mouseup', function(event) {

                var $this_table_wrapper = $(event.currentTarget);

                isDown = false;

                $this_table_wrapper.removeClass(table_wrapper_active_class);

            });

        }

        function setupResponsiveTable() {

            $table.wrap('<div class="table-responsive"></div>');

            // Setup Overflow Chevron 
            // Provide visual indicators that table is scrollable
            var $this_table_rows = $table.find("tbody tr");
        
            if ($this_table_rows.length > 2) {
        
                $this_table_rows.filter(":nth-child(2)").addClass(overflow_chevron_class);
        
            } else {
        
                $this_table_rows.filter(":first").addClass(overflow_chevron_class);
        
            }

        }

        function init($table_arg) {

            $table = $table_arg;

            setupResponsiveTable();

            setupDragToScroll();

        }

        var $table;

        var table_wrapper_active_class = "table-responsive--active";
        var overflow_chevron_class = "table-row--overflow-chevron";

        var isDown = false;
        var startX;
        var scrollLeft;

        return {
            init: init
        }

     };
        
     document.addEventListener("DOMContentLoaded", function () {

        var $tables = $('.main *:not(.table-responsive) > table');      

        if ($tables.length) {

            $tables.each(function( index ) {
                
                var $this_table = $(this);

                // Instantiate the object instance
                var responsiveTableInstance = squiz.fn.responsiveTable();

                responsiveTableInstance.init($this_table);

            });

        }

     });
    
}());
